import { render } from "./Use.vue?vue&type=template&id=532ba1ef&scoped=true&ts=true"
import script from "./Use.vue?vue&type=script&lang=ts"
export * from "./Use.vue?vue&type=script&lang=ts"

import "./Use.vue?vue&type=style&index=0&id=532ba1ef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532ba1ef"]])

export default __exports__